<div class="edition-switcher-materials">
    <h4>Materialien zu diesem Buch</h4>

    @if (!applicationStateService.bookConfig.additionals || applicationStateService.bookConfig.additionals.length === 0) {
        <div>
            Es sind keine weiteren Materialien verfügbar.
        </div>
    }

    @if (applicationStateService.bookConfig.additionals &&
    applicationStateService.bookConfig.additionals.length > 0) {
        <div class="booklist-additional-list">
            @for (additional of applicationStateService.bookConfig.additionals; track additional) {
                <div class="booklist-additional-row">
                    <div class="booklist-additional-actions">
                        <small class="date">{{ additional.lastUpdated | date: 'dd.MM.yyyy' }}</small>
                        @if (additional.productLink) {
                            <a class="btn btn-sm btn-round btn-open btn-inverse btn-semibold" href="{{ additional.productLink }}"
                               target="_blank" title="Link zum Produkt">
                                <i aria-hidden="true" class="fa fa-shopping-cart"></i>
                            </a>
                        }
                        @if (!additional.productLink) {
                            <span class="btn btn-sm btn-round btn-open btn-inverse btn-semibold disabled"
                                  data-bs-toggle="tooltip"
                                  title="Dieses Material ist leider nicht als Printbuch bestellbar.">
                <i aria-hidden="true" class="fa fa-shopping-cart"></i>
              </span>
                        }
                        @if (additional.files && additional.files.length > 0) {
                            <div class="dropdown">
                                <button aria-expanded="true"
                                        aria-haspopup="true" class="btn btn-sm btn-round btn-open btn-inverse btn-semibold dropdown-toggle"
                                        data-bs-toggle="dropdown" id="materialsDownload-{{ additional.id }}" title="Teilen"
                                        type="button">
                                    <i aria-hidden="true" class="fa fa-share"></i> <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    @for (additionalFile of additional.files; track additionalFile) {
                                        @if (additionalFile.bookLink) {
                                            <li>
                                                <a class="dropdown-item" href="{{ additionalFile.bookLink }}"
                                                   target="_blank">
                                                    <i aria-hidden="true" class="fa fa-book"></i> Digi.Buch öffnen
                                                </a>
                                            </li>
                                        }
                                        @if (additionalFile.link) {
                                            <li>
                                                @if (!applicationStateService.userData?.bookAccessCode) {
                                                    <button (click)="openDisabledMaterialModal()" class="dropdown-item">
                                                        <ng-template [ngTemplateOutlet]="downloadLinkContent"/>
                                                    </button>
                                                }
                                                @if (applicationStateService.userData?.bookAccessCode) {
                                                    <a class="dropdown-item" href="{{ additionalFile.link }}">
                                                        <ng-template [ngTemplateOutlet]="downloadLinkContent"/>
                                                    </a>
                                                }
                                                <ng-template #downloadLinkContent>
                                                    @if (additionalFile.isPdf) {
                                                        <i class="far fa-file-pdf"></i>
                                                        @if (additionalFile.title) {
                                                            {{ additionalFile.title }}
                                                        }
                                                        @if (!additionalFile.title) {
                                                            PDF-Datei
                                                        }
                                                    }
                                                    @if (additionalFile.isWord) {
                                                        <i class="far fa-file-word"></i>
                                                        @if (additionalFile.title) {
                                                            {{ additionalFile.title }}
                                                        }
                                                        @if (!additionalFile.title) {
                                                            Word-Datei
                                                        }
                                                    }
                                                    @if (additionalFile.isExcel) {
                                                        <i class="far fa-file-excel"></i>
                                                        @if (additionalFile.title) {
                                                            {{ additionalFile.title }}
                                                        }
                                                        @if (!additionalFile.title) {
                                                            Excel-Datei
                                                        }
                                                    }
                                                    herunterladen
                                                </ng-template>
                                            </li>
                                        }
                                        @if (additionalFile.bookLink && additional.files.length > 1) {
                                            <li class="divider" role="separator"
                                            ></li>
                                        }
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                    <span class="booklist-additional-name-container">
            <img alt="{{ additional.title }}" class="booklist-additional-image" data-bs-toggle="tooltip" height="25"
                 src="{{ additional.typeIconUrl }}" width="25"/>
                        {{ additional.title }}
          </span>
                </div>
            }
        </div>
    }
</div>